/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-06 15:18:09
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-24 19:11:41
 * @name: 主文件
 * @Description: 主文件
 * @FilePath: \preSaleNafterSaleBackstage\src\main.js
 * @Author: DESKTOP-1QU67QM
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router' //路由
import store from './store' //vuex
import ElementUI from 'element-ui'; //element组件
import 'element-ui/lib/theme-chalk/index.css'; //element 样式
import '@/components/ef/index.css'; //easyflow 样式
import '@/assets/scss/reset.scss'; //全局默认样式
import cookie from '@/storage/cookie'; //cookie对象
import session from '@/storage/session'; //session对象
import localstorage from '@/storage/localstorage'; //localstorage对象
import scssVars from '@/scss/var.scss'; //scss变量
import globalComponents from '@/globalComponents'; //全局组件
import commonUtil from '@/utils/common.js'; //全局方法
import '@/entrance'; //入口文件
import 'mv-full-page/lib-dist/mv-full-page.css'
import MvFullPage from 'mv-full-page'

Vue.use(MvFullPage)
Vue.use(ElementUI);
Vue.use(globalComponents);

Vue.config.productionTip = false
Vue.prototype.$storage = {
  cookie: new cookie(),
  session: new session(),
  localstorage: new localstorage(),
}
Vue.prototype.$scssVars = scssVars;
Vue.prototype.$commonUtil = commonUtil;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
